<template>
  <div id="main">
    <h2>Welcome to Owal Faces</h2>
    <div v-if="isLoggedIn">
      To see the list of enrolled faces, go to <router-link to="/faces">Faces List</router-link>.

      There, you can see who walked where. Tip: Check out the Filter feature for quick lookup!

      <br/>

      To help us train the detector, click <router-link to="/detected">Faces Detected</router-link>. It becomes more accurate with every click!
    </div>
    <div v-else>
      To start, please <router-link to="/login">log in</router-link>.
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
  name: 'main',
  computed: mapGetters(['isLoggedIn'])
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Main.vue?745d9d60